import type { ReactElement } from 'react';
import { Box, Container, Link, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Imprint = (): ReactElement => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Container
      maxWidth="lg"
      sx={{ paddingTop: theme.spacing(6) }}
      data-testid="container"
    >
      <Box sx={{ marginBottom: theme.spacing(5) }}>
        <Typography align="center" variant="h2">
          {t('legal:imprint:title')}
        </Typography>
      </Box>

      <Box
        sx={{
          textAlign: 'center',
          marginBottom: theme.spacing(5),
          '& > *': {
            marginBottom: theme.spacing(3),
          },
        }}
      >
        <Typography variant="h4">Loudly GmbH</Typography>
        <Typography variant="body1">Quedlinburger Str. 1</Typography>
        <Typography variant="body1">10589 Berlin</Typography>
        <Typography variant="body1">Rory Kenny</Typography>
        <Typography variant="body1">Telephone: +49 (0) 30 20293920</Typography>
        <Typography variant="body1">
          Email: <Link href="mailto:help@loudly.com">help@loudly.com</Link>
        </Typography>
        <Typography variant="body1">
          Amtsgericht Berlin Charlottenburg: HRB 135131 B
        </Typography>
        <Typography variant="body1">Ust.ID Nr.: DE 277 917 685</Typography>
      </Box>

      <Box
        sx={{
          '& > *': {
            marginBottom: theme.spacing(3),
          },
        }}
      >
        <Typography variant="h4">
          {t('legal:imprint:sections:1:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:1:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:1:paragraphs:2')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:1:paragraphs:3')}
        </Typography>

        <Typography variant="h4">
          {t('legal:imprint:sections:2:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:2:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:2:paragraphs:2')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:2:paragraphs:3')}
        </Typography>

        <Typography variant="h4">
          {t('legal:imprint:sections:3:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:3:paragraphs:1')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:3:paragraphs:2')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:3:paragraphs:3')}
        </Typography>

        <Typography variant="h4">
          {t('legal:imprint:sections:4:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:4:paragraphs:1')}
        </Typography>

        <Typography variant="h4">
          {t('legal:imprint:sections:5:title')}
        </Typography>
        <Typography variant="body1">
          {t('legal:imprint:sections:5:paragraphs:1')}
        </Typography>
      </Box>
    </Container>
  );
};

export default Imprint;
